/**
 * Cliente API Processo Administrativo (ARCA).
 */
import { apiFetch, getToken } from '../../../api/client';
import { withUnidade } from '../../../utils/storageByUnit';
import API_CONFIG from '../../../config/api';

export function paUrl(path, unidadeSelecionada) {
  return withUnidade(path, unidadeSelecionada);
}

export async function paJson(path, unidadeSelecionada, options = {}) {
  const res = await apiFetch(paUrl(path, unidadeSelecionada), {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  const raw = await res.text();
  let data = {};
  try {
    data = raw ? JSON.parse(raw) : {};
  } catch {
    data = {};
  }
  if (!res.ok) {
    const detail =
      data.error ||
      data.message ||
      (raw && raw.length < 300 ? raw.replace(/<[^>]+>/g, ' ').trim() : '') ||
      `HTTP ${res.status}`;
    throw new Error(detail);
  }
  return data;
}

/** Upload multipart (sem Content-Type manual — o browser define o boundary). */
export async function paUpload(path, unidadeSelecionada, formData) {
  const res = await apiFetch(paUrl(path, unidadeSelecionada), {
    method: 'POST',
    body: formData,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || data.message || `HTTP ${res.status}`);
  return data;
}

export function paDownloadUrl(apiPath, unidadeSelecionada) {
  const base = paUrl(apiPath, unidadeSelecionada);
  const token = getToken();
  const full = `${API_CONFIG.BACKEND_URL}${base}`;
  if (!token) return full;
  return full.includes('?')
    ? `${full}&access_token=${encodeURIComponent(token)}`
    : `${full}?access_token=${encodeURIComponent(token)}`;
}
